import { useState } from "react";
import { toast } from "react-toastify";
import Handler from '../../Helpers/Handler'
import { reloadWindow } from '../../Helpers/Utils'

const Email = () => {
    const [otpSent, setOtpSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resendTimer, setResendTimer] = useState(120);
    const [canResend, setCanResend] = useState(false);
    const [data, setData] = useState({ number: "", otp: "" });
    const validateEmail = () => {
        const validEmail = new RegExp('([a-z0-9.]{2,})+@([a-z]{3,})+([.]{1})+[a-z]{2,3}')
        if (!data.email) {
            toast.error("Email ID is required")
            return false;
        }
        if (!validEmail.test(data.email)) {
            toast.error("Enter a valid email ID")
            return false;
        }
        return true;
    };
    const validateOtp = () => {
        const otpRegex = /^\d{5}$/;
        if (!data.otp) {
            toast.error("OTP is required")
            return false;
        }
        if (!otpRegex.test(data.otp)) {
            toast.error("OTP must be 5 digits")
            return false;
        }
        return true;
    };
    const sendOtp = async () => {
        if (!validateEmail()) return;
        setLoading(true);
        const response = await Handler({ method: 'PATCH', url: `/customer/email/send-otp`, data: { email: data.email } })
        setLoading(false);
        if (response?.success) {
            setOtpSent(true);
            toast.success("OTP sent successfully")
            setOtpSent(true);
            setCanResend(false);
            setResendTimer(120);

            const interval = setInterval(() => {
                setResendTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        setCanResend(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        } else {
            toast.error(response?.message || "Failed to send OTP")
        }

    };
    const verifyOtp = async () => {
        if (!validateEmail() || !validateOtp()) return;
        setLoading(true);
        const response = await Handler({ method: 'PATCH', url: `/customer/email/verify-otp`, data: { email: data.email, otp: data.otp } })
        if (response?.success) {
            toast.success("Email verified successfully")
            setTimeout(() => {
                reloadWindow()
                setLoading(false);
            }, 2000);
        } else {
            toast.error(response?.message || "Invalid OTP")
            setLoading(false);
        }
    };

    return (
        <>
            <div className="mb-3">
                <label className="form-label">Email ID</label>
                <input type="email" autoComplete="off" className={`form-control`} value={data.email} onChange={(e) => setData((prev) => ({ ...prev, email: e.target.value }))} placeholder="Enter Email Id" />
            </div>
            {!otpSent ? (
                <div className="text-center" ><button className="btn btn-primary" onClick={sendOtp} disabled={loading}>{loading ? "Sending..." : "Send OTP"}</button></div>
            ) : (
                <>
                    <div className="mb-3">
                        <label className="form-label">OTP</label>
                        <input type="text" maxLength={5} className={`form-control `} value={data.otp} onChange={(e) => setData((prev) => ({ ...prev, otp: e.target.value.replace(/\D/g, "") }))} placeholder="Enter OTP" />
                    </div>
                    <div className="d-flex justify-content-end">
                        <button className="fs-7 btn btn-link" onClick={sendOtp} disabled={loading || !canResend}>{canResend ? "Resend OTP" : `Resend in ${resendTimer}s`}</button>
                    </div>
                    <div className="text-center">
                        <button className="btn btn-success" onClick={verifyOtp} disabled={loading}>{loading ? "Verifying..." : "Verify OTP"}</button>
                    </div>
                </>
            )}
        </>
    );
};

export default Email;